const safeParse = (rawValue) => {
   if (rawValue === null || rawValue === undefined) return null;
   if (rawValue === "undefined" || rawValue === "null" || rawValue === "") return null;

   try {
      return JSON.parse(rawValue);
   } catch (error) {
      return null;
   }
};

export const LocalStorageService = {
   setItem(key, value) {
      localStorage.setItem(key, JSON.stringify(value));
   },

   getItem(key) {
      return safeParse(localStorage.getItem(key));
   },

   clear() {
      localStorage.clear();
   },

   removeItem(key) {
      localStorage.removeItem(key);
   }
};
